export default __webpack_public_path__ + "static/media/001-matryoshka doll.5a0783c2.svg";